module.exports = __webpack_public_path__ + "static/media/box.991518aa.svg";